import { AxiosInstance } from "axios";

export function withCaptchaToken<T extends AxiosInstance>(client: T, captchaToken: string): T {
    client.defaults.headers['cf-turnstile-response'] = captchaToken;
    return client;
}
